<form [formGroup]="formGroup" (submit)="submit()">
  <div class="text-center">
    {{
      'request_form.status.cancel_reason.choose_cancellation_initiator'
        | translate
    }}
  </div>
  <tui-textfield
    tuiChevron
    tuiTextfieldSize="m"
    class="mt-3"
    (click)="promoteNestedDropdownZIndex()"
    (focusin)="promoteNestedDropdownZIndex()"
  >
    <input tuiSelect [formControlName]="FormFields.Reason" />
    <tui-data-list-wrapper *tuiDropdown [items]="items"></tui-data-list-wrapper>
  </tui-textfield>
  @if (reasonField?.touched && reasonField?.errors?.['required']) {
    <tui-error
      [error]="'request_form.status.cancel_reason.no_value_error' | translate"
    ></tui-error>
  }
  <div class="flex justify-end mt-3">
    <button
      tuiButton
      type="button"
      size="m"
      class="mr-3"
      appearance="blue"
      (click)="dismiss()"
    >
      {{ 'request_form.status.cancel_reason.close' | translate }}
    </button>
    <button
      tuiButton
      type="submit"
      size="m"
      appearance="primary"
      [disabled]="formGroup.invalid"
    >
      {{ 'request_form.status.cancel_reason.change' | translate }}
    </button>
  </div>
</form>
